// extracted by mini-css-extract-plugin
export default {"fullScreenContainer":"FullScreenContainer_fullScreenContainer__ie1bY"};